import React from "react";
import { MyList } from "../../_myBase/components/myList";
import useFieldPreferences from "../../hooks/useFieldPreferences";
import { hostLogFields, hostLogFilters } from "../host_logs/hostLogFields";

export default function MyHostLogsList(props) {
  const { visibleFields, loading, updatePreference } = useFieldPreferences(
    "my-host-logs",
    hostLogFields.map((f) => f.name)
  );

  if (loading) return <div>Loading...</div>;

  const filteredFields = hostLogFields.filter((field) =>
    visibleFields.includes(field.name)
  );

  return (
    <MyList
      resource="host-logs/my-logs"
      basePath="/my-host-logs"
      {...props}
      filters={hostLogFilters}
      fields={hostLogFields.map((f) => f.name)}
      onPreferencesUpdate={updatePreference}
    >
      {filteredFields.map(
        ({ name, component: Component, props: fieldProps }) => (
          <Component key={name} source={name} {...fieldProps} />
        )
      )}
    </MyList>
  );
}
